<template>
    <section class="donate">
        <div class="container">
            <section class="header">
                <div class="donate_filed">
                    <div class="donate_text">
                        <div class="col-7 s12 m7">
                            <p class="header">How much would you like to donate?</p>
                            <div class="horizontal">
                            <div class="card-stacked">
                                <div class="card-content" v-for="donate in donates" :key="donate.id">
                                    <div class="wrapper">
                                        <form class="form-inline">
                                            <label class="sr-only" for="inlineFormInputGroup">Amount</label>
                                            <div class="input-group mb-2 mb-sm-0">
                                                <div class="input-group-addon currency-addon">
                                                <select class="currency-selector">
                                                <option data-symbol="$" selected>USD</option>
                                                <option data-symbol="€">EUR</option>
                                                <option data-symbol="£">GBP</option>
                                                <option data-symbol="¥">JPY</option>
                                                <option data-symbol="$">CAD</option>
                                                <option data-symbol="$">AUD</option>
                                                </select><i class="fas fa-chevron-down"></i>
                                            </div>
                                            <div class="donate_input">
                                            <input 
                                               type="number" 
                                               class="form-control currency-amount" 
                                               id="inlineFormInputGroup"  
                                               size="8"
                                                v-if="donate.edit"
                                                v-model="donate.title"
                                                @blur="donate.edit = false; $emit('update')"                                             
                                                v-focus
                                            >
                                            <div v-else class="currency-amount">
                                                <label> {{donate.title}} </label>
                                            </div>
                                            </div>
                                            <!--@keyup.enter="donate.edit=false; $emit('update')" <div class="input-group-addon currency-symbol">$</div> -->
                                            </div>
                                        </form>
                                    </div>
                                   <div class="donate_amount row">
                                       <p @click="donate.title = '30.00'">30</p>
                                       <p @click="donate.title = '50.00'">50</p>
                                       <p @click="donate.title = '70.00'">70</p>
                                       <p @click="donate.title = '100.00'">100</p>
                                       <p @click="donate.title = '150.00'">150</p>
                                       <p @click="donate.title = '200.00'">200</p>
                                       <p @click="donate.edit = true;">Custom Value</p>
                                    </div>
                                   <p class="header">Would you like to donate this to a specific campaign?</p>
                                </div>
                                <div class="bottom_card_d">
                                    <div class="dropdown">
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item">Education</a>
                                            <a class="dropdown-item">Local community</a>
                                            <a class="dropdown-item">Children & youth</a>
                                            <a class="dropdown-item">Health & medical</a>
                                            <a class="dropdown-item">International aid</a>
                                            <a class="dropdown-item">Gardens & Environment</a>
                                        </div>
                                        <a class="dropdown-toggle" data-toggle="dropdown">Select Donation Type</a>
                                    </div>
                                    <button>DONATE NOW</button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text_body">
                        <div class="text">
                            <div class="getting_body"> 
                                <span class="getting_line"></span> 
                                    <p>A help to those who need it</p>
                            </div>
                            <h2>Each donation is an essential help for everyone's life</h2>
                            <div class="watch_body">
                                <img src="../../assets/img/play_button.png" alt="">
                                 <p>Watch Video</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="image_body">
                            <img src="../../assets/img/donate_cover.png" alt="">
                        </div>
                    </div>
                </div>
            </section>
            <section class="section_2">
                <div class="donate_list">
                    <div class="header_text">
                        <h2>More Ways To Make An Impact</h2>
                    </div>
                </div>
                <section class="gallary" id="show-on-scroll">
            <div class="container">
                <div class="gallary_body">
                    <div class="image_hover" data-aos="zoom-in">
                      <figure> <img src="../../assets/img/donate_1.png" alt=""></figure>
                          <h5>Education for every child</h5>
                          <p>Be tree their face won't appear day waters moved fourth in they're divide don't a you were man face god.</p>
                        <div class="raise_currency">
                            <b>Raised:</b><b> $1533</b>
                            <div class="goal_currency">
                              <b>Goal:</b><b> $1533</b>
                            </div>
                        </div>
                        <div class="button_body">
                          <button>DONATE</button>
                        </div>
                    </div>
                    <div class="image_hover" data-aos="zoom-in">
                        <figure>  <img src="../../assets/img/donate_2.png" alt=""></figure>
                          <h5>Education for every child</h5>
                          <p>Be tree their face won't appear day waters moved fourth in they're divide don't a you were man face god.</p>
                        <div class="raise_currency">
                            <b>Raised:</b><b> $1533</b>
                            <div class="goal_currency">
                              <b>Goal:</b><b> $1533</b>
                            </div>
                        </div>
                        <div class="button_body">
                          <button>DONATE</button>
                        </div>
                    </div>
                    <div class="image_hover" data-aos="zoom-in">
                        <figure>  <img src="../../assets/img/donate_3.png" alt=""></figure>
                          <h5>Education for every child</h5>
                          <p>Be tree their face won't appear day waters moved fourth in they're divide don't a you were man face god.</p>
                        <div class="raise_currency">
                            <b>Raised:</b><b> $1533</b>
                            <div class="goal_currency">
                              <b>Goal:</b><b> $1533</b>
                            </div>
                        </div>
                        <div class="button_body">
                          <button>DONATE</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
            </section>
        </div>
    </section>
</template>
<script>
export default {
    data() {
    return {
    donates: [
          { title: '750.00', edit: false },
    ],
  }
    },
  methods: {

  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }
}
</script>
<style scoped>
.donate{
    margin-top: 5vh;
}
.donate .section_2{
    margin-bottom: 40px;
}
.donate .donate_text p{
    cursor: pointer;
}
.donate .donate_input{
    width: 77.5%;
}
.donate .donate_input label{
        margin-top: 0rem;
}
.donate .wrapper .currency-selector{
    margin: 0;
    outline: none;
    cursor: pointer;
    background:none;
    z-index: 101;
}
.donate_list .header_text h2{
    text-align: center;
}
.donate .gallary .image_hover h5, .donate .gallary .image_hover p,.donate .gallary .image_hover .button_body{
    padding: 0px 35px 0px 20px;
    margin-top: 5px;
    line-height: normal;
}
.donate .gallary .image_hover button{
   width: auto;
   padding: 8px 20px;
}
.gallary_body {
    grid-gap: 2rem;
}
.goal_currency{
    float: right;
}
.donate .gallary_body img{
    height: auto;
}
.raise_currency{
   padding: 0px 35px 0px 20px;
}
.donate .gallary .image_hover h5,.donate .gallary .image_hover .button_body{
   margin-top: 20px;
}
.goal_currency b{
  color: #07CDDB;
}
.donate .wrapper .form-inline .input-group{
 height: auto;
 width: 100%;
 border-radius:0;
}
.donate .wrapper .form-inline .input-group i{
    position: absolute;
    right: 5px;
    align-items: flex-start;
    margin-top: 14px;
}
.donate .wrapper .form-inline{
    margin-left: 0 !important;
}
.donate .currency-addon{
    width: 4em;
    text-align: left;
    position: relative;
}
.donate .currency-selector option:hover,.donate .currency-selector option:focus{
   background-color:#B4F5F9 !important;
   color: black !important;
}
.donate .wrapper .currency-amount {
    border: 1px solid #d4d4d4;
    border-radius: 0 !important;
    text-align: center;
    font-weight: 500;
    color: #000;
    font-size: 18px;
    margin: 0;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    width: 100%;
}
.donate .wrapper .currency-amount::placeholder{
  color: #000000;
  font-size: 18px;
}
.donate .wrapper .input-group {
    border: 0px solid #d4d4d4;
}
.donate .dropdown{
    position: relative;
    display: inline-block;
    padding: 0px;
    width: 100%;
    z-index: 1032;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 0.6000000238418579px solid #000000;
    opacity: 1;
    cursor: pointer;
    margin-bottom: 20px;
}
.donate .dropdown-toggle{
   padding: 4px 80px;
   color: #828282;
   opacity: 1;
   font-weight: 500;
}
.donate button{
    background: #07CDDB 0% 0% no-repeat padding-box;
    opacity: 1;
    width: 100%;
    padding: 5px;
    font-weight: 700;
    margin: 0px 0px 20px 0px;
}
.donate .dropdown-menu.show{
    transform: translate3d(0px, 30px, 0px) !important;
    width: 100%;
}
.donate .donate_amount p{
    padding: 0px 20px;
    background-color:#B4F5F9;
    margin: 6px 2px;
    font-weight: 600;
}
.donate .dropdown-item:hover{
   background-color:#B4F5F9;
   color: black;
}
.donate .donate_amount{
    display: flex;
    padding: 10px 0px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
 .donate .header .text_body{
     display: flex;
     align-items: center;
 }
 .donate .getting_line{
     width: 45px;
     height: 2px;
     background-color: #07CDDB;
 }
 .donate .donate_filed{
   display: flex;
   justify-content: center;
   align-items: self-end;
 }
 .donate .donate_filed .donate_text{
  position: absolute;
  margin-top: 12vw;
  z-index: 1011;
 }
 .donate .donate_filed .donate_text .s12{
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
 }

 .donate .donate_text .header{
    font-weight: 700;
    text-align: left;
    margin-bottom: 0.5rem;
    line-height: normal;
    margin-top: 10px;
 }
 .donate .getting_body{
    display: flex;
    align-items: center;
 }
  .donate .getting_body p{
      margin-bottom: 0px;
      margin-left: 20px;
      color: #07CDDB;
  }
 .donate .header .text_body .text{
     width: 60%;
     text-align: left;
 }
  .donate .header .text_body .text h2{
      line-height: normal;
  }
  .donate .header .image_body img{
      padding: 80px 40px 100px 80px;
  }
  .donate .watch_body{
    padding: 20px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .donate .watch_body img{
    width: 22%;
  }
  .donate .watch_body p{
    padding: 10px;
    margin-top: 10px;
  }
.currency-selector {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-left: .5rem;
  border: 0;
  background: transparent;
  
  -webkit-appearance:none;
  -moz-appearance:none;
  appearance:none;
  
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='1024' height='640'><path d='M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z'></path></svg>") 90%/12px 6px no-repeat;
  
  font-family: inherit;
  color: inherit;
}

.currency-amount {
  text-align: right;
}

.currency-addon {
  width: 6em;
  text-align: left;
  position: relative;
}
</style>